import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ManagementComponent } from './pages/management/management.component';
import { PagenotfoundComponent } from './shared/components/pagenotfound/pagenotfound.component';

export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'full', component: DashboardComponent },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/dashboard',
    loadChildren: () =>
      import('./pages/onboarding-dashboard/onboarding-dashboard.module').then(
        m => m.OnboardingDashboardModule
      ),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/transactions',
    loadChildren: () =>
      import('./pages/transactions/transactions.module').then(
        m => m.TransactionsModule
      ),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/settings',
    loadChildren: () =>
      import('./pages/settings/settings.module').then(m => m.SettingsModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/portfolio-group',
    children: [
      {
        path: 'portfolio',
        loadChildren: () =>
          import('./pages/portfolio/portfolio.module').then(
            m => m.PortfolioModule
          ),
      },
      {
        path: 'quarterly-data',
        loadChildren: () =>
          import('./pages/quarterly-data/quarterly-data.module').then(
            m => m.QuarterlyDataModule
          ),
      },
      {
        path: 'investors',
        loadChildren: () =>
          import('./pages/investors/investors.module').then(
            m => m.InvestorsModule
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.module').then(m => m.ReportsModule),
      },
      {
        path: 'new-reports',
        loadChildren: () =>
          import('./pages/new-reports/new-reports.module').then(
            m => m.NewReportsModule
          ),
      },
    ],
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/workspace-group',
    children: [
      {
        path: 'documents',
        loadChildren: () =>
          import('./pages/documents/documents.module').then(
            m => m.DocumentsModule
          ),
      },
    ],
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/management',
    component: ManagementComponent,
    title: 'Suite 7 GP Portal - Management',
    canActivate: [AuthGuard],
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/reports',
    loadChildren: () =>
      import('./pages/reports/reports.module').then(m => m.ReportsModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/documents',
    loadChildren: () =>
      import('./pages/documents/documents.module').then(m => m.DocumentsModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/investors',
    data: { onboardedInvestorSource: true },
    loadChildren: () =>
      import('./pages/investors/investors.module').then(m => m.InvestorsModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/onboarding',
    loadChildren: () =>
      import('./pages/onboarding/onboarding.module').then(
        m => m.OnboardingModule
      ),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/chats',
    loadChildren: () =>
      import('./pages/chats/chats.module').then(m => m.ChatsModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/faq',
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/portfolio',
    loadChildren: () =>
      import('./pages/portfolio/portfolio.module').then(m => m.PortfolioModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/chat',
    loadChildren: () =>
      import('./pages/chat/chat.module').then(m => m.ChatModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/team',
    loadChildren: () =>
      import('./pages/team/team.module').then(m => m.TeamModule),
  },
  {
    path: 'gp/:gpId/vehicle/:vehicleId/quarterly-data',
    loadChildren: () =>
      import('./pages/quarterly-data/quarterly-data.module').then(
        m => m.QuarterlyDataModule
      ),
  },
  { path: '**', component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
